import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { BackboneSelectOption } from '../../../types/backbone'
import { SelectOption } from './types'
import { useBackboneData } from './useBackboneData'
import { backboneToOption } from './utils'

export interface BackboneSelectProps {
  fieldName: string
  productId: number
  onSelectedBackbone?: React.Dispatch<
    React.SetStateAction<BackboneSelectOption[] | undefined>
  >
  onSelectedResolution?: React.Dispatch<
    React.SetStateAction<SelectOption | undefined>
  >
}

const BackboneSelect = ({
  fieldName,
  productId,
  onSelectedBackbone,
  onSelectedResolution,
}: BackboneSelectProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField<BackboneSelectOption[]>(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  const { backbones, backbonesDft, backbonesIsLoading } = useBackboneData(
    productId
  )
  const resolutionDftValue = { value: 'standard', label: 'Standard' }

  const toOption = backboneToOption()

  useEffect(() => {
    if (!backbonesIsLoading && backbonesDft.length > 0) {
      setValue(backbonesDft.map(toOption))
      if (onSelectedBackbone) {
        onSelectedBackbone(backbonesDft.map(toOption))
      }
      if (onSelectedResolution) {
        onSelectedResolution(resolutionDftValue)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backbonesIsLoading, backbonesDft])

  return (
    <div id="divBackboneId">
      <AdvancedSelect
        name={name}
        id={name}
        label={t('Backbone')}
        value={value}
        onChange={(v: any | null) => {
          setValue(v)
          if (onSelectedBackbone) {
            onSelectedBackbone(v)
          }
          if (
            onSelectedResolution &&
            (v === undefined || v === null || v.length === 0)
          ) {
            onSelectedResolution(resolutionDftValue)
          }
        }}
        isMulti
        onBlur={() => setTouched(true)}
        options={backbones ? backbones.map(toOption) : []}
        error={!!(error && touched)}
        errorMessage={error}
        isDisabled={backbonesIsLoading || isSubmitting}
        noOptionsMessage={() => t('No backbone found')}
        placeholder={backbones ? t('Select...') : t('Loading options...')}
      />
    </div>
  )
}

export default BackboneSelect
